<template>
  <ion-app>
    <!--icons-->
    <vox-icons/>
    <!--split pane layout-->
    <ion-split-pane when="lg"
                    content-id="menu-content"
                    @ionSplitPaneVisible="$root.$emit('ionSplitPaneVisible')">
      <!--side menu-->
      <main-menu ref="mainMenuComponent"></main-menu>
      <!--main content-->
      <ion-content id="menu-content">
        <loading v-if="loading"></loading>
        <main-header ref="mainHeaderComponent"></main-header>
        <div id="topOfDocument">
          <div class="main-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
        </div>
      </ion-content>
    </ion-split-pane>

    <ion-menu-controller ref="menuController"></ion-menu-controller>

  </ion-app>
</template>

<script>
import Loading from '@/components/Loading';
import MainHeader from '@/components/MainHeader';
import MainMenu from '@/components/MainMenu';

import {mapGetters} from 'vuex';
import {USER_REQUEST} from '@/store/actions/user';
import VoxIcons from "@/components/Icons.vue";

import WebPushNotifications from '@/services/WebPushNotifications';
import PushNotifications from '@/services/PushNotifications';
import Firestore from '@/services/Firestore';

import {Capacitor} from '@capacitor/core';
import Platform from '@/helpers/Platform.js';

import {Subject} from 'rxjs/Subject';
import {tap} from 'rxjs/operators';
import SwipeListener from 'swipe-listener';

export default {
  name: 'App',
  components: {
    VoxIcons,
    Loading,
    MainHeader,
    MainMenu
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'authStatus']),
    loading: function () {
      return this.authStatus === 'loading'
      //          return true
    }
  },
  methods: {
    handleNetworkChange() {
      if (navigator.onLine) {
        console.log('%c online ', 'background: #488000; color: #fff');
      } else {
        console.log('%c offline ', 'background: #E4030B; color: #fff');
        this.$ionic.alertController
            .create({
              header: 'Informacja',
              message: 'Połaczenie z internetem jest niedostępne.<br> Sprawdź ustwienia urzadzenia i spróbuj ponownie',
              buttons: ['OK'],
              mode: 'md'
            })
            .then(a => a.present())
      }
    },
    checkModernAppleVariants() {
      let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      let ratio = window.devicePixelRatio || 1;
      let screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
      };
      //
      if (iOS && screen.width == 1125 && screen.height === 2436) {
        this.iPhoneXDetected = true;
        console.log('iPhone X detected');
        document.getElementById('notch').style.height = "2.5em";
      } else {
        this.iPhoneXDetected = false;
        console.log('iPhone X not detected')
      }
    }
  },
  created() {
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
    }
    window.addEventListener("online", this.handleNetworkChange);
    window.addEventListener("offline", this.handleNetworkChange);
  },
  mounted() {
    setTimeout(() => {
      this.handleNetworkChange();
      this.checkModernAppleVariants();
    }, 300);

    setTimeout(() => {

      // -------------------------- o
      // add firebase services
      // with capacitor mobile

      if (Capacitor.platform !== 'web') {
        console.log("___________________r1111")
        // add push notifications
        PushNotifications.ngOnInit()
        Firestore.firestoreInit();
      }

      // -------------------------- o
      // add go back button listener

      document.addEventListener("backbutton", () => {
        this.$root.$emit('goingBack');
        this.$router.go(-1);
      });


      // -------------------------- o

      // TODO temp do not use web push notifications
      // TODO uncomment register service worker @ main.js
      // if (Capacitor.platform === 'web') {
      //   WebPushNotifications.requestPermissions();
      // }

    }, 5000);


    setTimeout(() => {
      if (Capacitor.platform === 'web') {
        console.log("___________________cookiebot init")
        this.$cookiebot.consentBanner()
      }
    }, 7000);

  }
}
</script>

<!-- Add global attributes -->
<style lang="scss">

@import "assets/sass/variables";
@import "assets/sass/helpers/mixins/breakpoint";

ion-content {
  --overflow: hidden !important; // custom scroll
  @include media-breakpoint-up(md) {
    --overflow: auto !important; // native scroll
  }
}

ion-alert {
  --max-width: 360px !important;
  --width: 85% !important;
}

#CookiebotWidget {
  top: 90px;
}
#CookiebotWidget.CookiebotWidget-open {
  overflow: visible!important;
}

#CybotCookiebotDialog .CybotCookiebotFader.CybotCookiebotDialogActive {
  opacity: 0!important;
}

</style>
